import { render, staticRenderFns } from "./ShippingPage.vue?vue&type=template&id=5f9510ec&scoped=true"
import script from "./ShippingPage.vue?vue&type=script&lang=js"
export * from "./ShippingPage.vue?vue&type=script&lang=js"
import style0 from "./ShippingPage.vue?vue&type=style&index=0&id=5f9510ec&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9510ec",
  null
  
)

export default component.exports